export const TYPO = {
  font: {
    // Resolve at runtime to keep a single source of truth with CSS vars
    get sans() {
      if (typeof window !== 'undefined') {
        const root = getComputedStyle(document.documentElement);
        const stack = root.getPropertyValue('--font-sans-stack').trim();
        const family = root.getPropertyValue('--font-sans').trim().replace(/^["']|["']$/g, '');
        if (stack) return stack;
        if (family) return `${family}, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif`;
      }
      return 'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';
    },
    get mono() {
      if (typeof window !== 'undefined') {
        const root = getComputedStyle(document.documentElement);
        const stack = root.getPropertyValue('--font-mono-stack').trim();
        const family = root.getPropertyValue('--font-mono').trim().replace(/^["']|["']$/g, '');
        if (stack) return stack;
        if (family) return `${family}, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace`;
      }
      return 'JetBrains Mono, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace';
    },
  },
  size: {
    xs: 11,
    sm: 12,
    base: 13,
    md: 14,
    lg: 16,
    xl: 18,
    "2xl": 22,
    "3xl": 28,
  },
  lineHeight: { tight: 1.2, normal: 1.5, relaxed: 1.6 },
  weight: { regular: 400, medium: 500, semibold: 600, bold: 700 },
  letter: { normal: '0', wide: '0.04em' },
  color: { primary: '#111111', muted: '#6B7280' }
};


